export default __webpack_public_path__ + "static/media/leftBg-dark.8a3e88f9.png";